import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import { Table } from "semantic-ui-react";
import { UserData } from "../../actions/authentificationActions";
import { getTsos } from "../../services/userService";
import { ITso } from "./CreateUserForm";
import { UsersTableRow } from "./UsersTableRow";
interface IProps {
    users: UserData[];
    setUsers: Dispatch<SetStateAction<UserData[]>>;
    localLoginEnabled: boolean;
}

export const UsersTable = ({ users, setUsers, localLoginEnabled }: IProps) => {
    const [tsos, setTsos] = useState<ITso[]>([]);

    const fetchTsos = useCallback(async () => {
        const res = await getTsos();
        const sortedTsos = [...res];
        sortedTsos.sort((a, b) => a.text.localeCompare(b.text));
        setTsos(sortedTsos);
    }, []);

    useEffect(() => {
        fetchTsos();
    }, [fetchTsos]);

    const handleUpdateUserRole = (user: UserData, newRole: string) =>
        setUsers(users.map(u => (u.guid === user.guid ? { ...u, role: newRole } : u)));

    const handleRemoveUser = (user: UserData) =>
        setUsers(users.filter((u: UserData) => u !== user));

    const handleUpdateUserTso = (user: UserData, newTso: string) => {
        setUsers(users.map(u => (u.guid === user.guid ? { ...u, tso: newTso } : u)));
    };

    const handleToggleUserEnabled = (user: UserData, isDisabled: boolean) => {
        setUsers(users.map(u => (u.guid === user.guid ? { ...u, isDisabled } : u)));
    };

    const handleToggleUserLocalLoginEnabled = (user: UserData, localLoginEnabled: boolean) => {
        setUsers(users.map(u => (u.guid === user.guid ? { ...u, localLoginEnabled } : u)));
    };

    return (
        <Table id="table-usersTable-a" striped basic="very" stackable>
            <Table.Header id="tableHeader-usersTable-a">
                <Table.Row id="tableRow-usersTable-a">
                    <Table.HeaderCell id="usersTable-user">User</Table.HeaderCell>
                    <Table.HeaderCell id="usersTable-username">Username</Table.HeaderCell>
                    <Table.HeaderCell id="usersTable-TSO">TSO</Table.HeaderCell>
                    <Table.HeaderCell id="usersTable-role">Role</Table.HeaderCell>
                    <Table.HeaderCell id="usersTable-lastLogin">Last login</Table.HeaderCell>
                    <Table.HeaderCell id="usersTable-enabled">Enabled</Table.HeaderCell>
                    {localLoginEnabled && (
                        <Table.HeaderCell id="usersTable-localLogin">
                            Local login enabled
                        </Table.HeaderCell>
                    )}
                    <Table.HeaderCell id="usersTable-actions">Actions</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body id="tableBody-usersTable">
                {users.map(u => (
                    <UsersTableRow
                        ind="usersTableRow-usersTable-a"
                        key={u.guid}
                        user={u}
                        tsos={tsos}
                        handleRemoveUser={handleRemoveUser}
                        handleUpdateUserRole={handleUpdateUserRole}
                        handleUpdateUserTso={handleUpdateUserTso}
                        handleToggleUserEnabled={handleToggleUserEnabled}
                        isLocalLoginEnabled={localLoginEnabled}
                        handleToggleLocalLoginUserEnabled={handleToggleUserLocalLoginEnabled}
                    />
                ))}
            </Table.Body>
        </Table>
    );
};
